import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { LanguageWelcomeMarquee } from "@/components/landing/LanguageWelcomeMarquee";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { HowItWorksDemo } from "@/components/landing/HowItWorksDemo";
import { ReaderDemo } from "@/components/landing/ReaderDemo";
import { Features } from "@/components/landing/Features";
import { LanguageCTAMarquee } from "@/components/landing/LanguageCTAMarquee";
import { Languages } from "@/components/landing/Languages";
import { DesktopOnly } from "@/components/landing/DesktopOnly";
// import { Pricing } from "@/components/landing/Pricing";
import { Faq } from "@/components/landing/Faq";
import { WaitlistCTA } from "@/components/landing/WaitlistCTA";
import { Footer } from "@/components/landing/Footer";
import { useReveal } from "@/hooks/useReveal";

const Landing = () => {
  const waitlistRef = useRef(null);
  useReveal();

  const scrollToWaitlist = () => {
    waitlistRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

    return (
      <div className="App relative">
        <Nav onCta={scrollToWaitlist} />
        <main className="relative z-10">
          <Hero onCta={scrollToWaitlist} />
          <HowItWorks />
          <HowItWorksDemo onCta={scrollToWaitlist} />
          <LanguageWelcomeMarquee />
          <ReaderDemo />
          <LanguageCTAMarquee />
          <Features />
          <Languages />
          <DesktopOnly />
          {/* <Pricing onCta={scrollToWaitlist} /> */}
          <Faq />
          <WaitlistCTA ref={waitlistRef} />
          <LanguageCTAMarquee />
          <Footer />
        </main>
        <Toaster richColors closeButton position="bottom-right" theme="dark" />
      </div>
    );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
